<div class="store-sync-progress-bar">
  <p>{{ percent | number: '1.0-0' }} %</p>

  <ui-progress-bar [value]="percent"></ui-progress-bar>

  <p *ngIf="label">{{ label }}</p>
</div>
